<template>
  <div class="pdf-report-residents">
    <NavBar class="nav--bar" />
    <AuthBySessionExpired class="auth--by--session--expired" />
    <div class="container">
      <b-modal id="filter" no-close-on-backdrop hide-footer title="FILTRAR">
        <div class="container">
          <div class="row">
            <div class="col-md-12 pt-0 pb-0">
              <label class="m-0">RESIDENTES ATIVOS/INATIVOS/TODOS</label>
              <select
                v-model="resident_active"
                class="form-control"
                @change="getResidents"
              >
                <option value="TODOS">TODOS</option>
                <option value="ATIVO">ATIVOS</option>
                <option value="INATIVO">INATIVOS</option>
              </select>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <label class="m-0">RESIDENTE/TODOS</label>
              <select v-model="resident_id" class="form-control">
                <option value="">TODOS</option>
                <option
                  v-for="(resident, key) in residents"
                  :key="key"
                  :value="resident.id"
                >
                  {{ String(resident.name).toUpperCase() }} -
                  {{ String(resident.status_type_name).toUpperCase() }}
                </option>
              </select>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <label class="m-0">Grau de dependência</label>
              <select v-model="degree_of_dependence_id" class="form-control">
                <option value="">TODOS</option>
                <option
                  v-for="(typeFilterByGrau, key) in typesFilterByGrau"
                  :key="key"
                  :value="typeFilterByGrau.value"
                >
                  {{ typeFilterByGrau.text }}
                </option>
              </select>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <label class="m-0">Gênero</label>
              <select v-model="gender_id" class="form-control">
                <option value="">TODOS</option>
                <option
                  v-for="(gender, key) in genders"
                  :key="key"
                  :value="gender.value"
                >
                  {{ gender.text }}
                </option>
              </select>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <ErrorsMessages :errors="errors" />
            </div>
            <div class="col-md-12 text-right">
              <v-btn
                :disabled="loading"
                @click="paginate()"
                class="btn-filter"
                type="relief"
                ><i class="fas fa-filter mr-2 text-twenty"></i>
                {{ loading ? "CARREGANDO" : "FILTRAR" }}
              </v-btn>
            </div>
          </div>
        </div>
      </b-modal>
      <div class="row content-filter">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return mb-3" @click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO: RESIDENTES POR GRAU DE DEPENDÊNCIA
          </h1>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="data.length == 0"
            @click="handleToPrint"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="data.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <div class="table-always">
          <div class="row">
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
              <img
                v-if="rest_home_logo_url"
                class="rest_home_logo_url"
                :src="rest_home_logo_url"
              />
              <div v-if="!rest_home_logo_url" class="ml-1">
                <strong class="text-uppercase">{{ rest_home_name }}</strong>
              </div>
            </div>
            <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 text-center">
              <h6 class="legends mb-0 worksansr">
                <strong>{{ user.rest_home_fantasy_name }}</strong>
              </h6>
              <h6
                class="legends mb-0 worksansr"
                v-if="user.rest_home_first_phone"
              >
                <strong>Telefone:</strong>
                {{ user.rest_home_first_phone }}
              </h6>
              <h6 class="legends mb-0 worksansr" v-if="user.rest_home_cnpj">
                <strong>CNPJ:</strong>
                {{ user.rest_home_cnpj }}
              </h6>
            </div>
            <div
              class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
            >
              <img
                class="logo"
                src="https://sistemclinupload.s3.amazonaws.com/logo.png"
                width="180"
              />
            </div>
          </div>
        </div>
        <table class="table table-sm">
          <thead>
            <tr>
              <th></th>
              <th>Nome</th>
              <th>CPF</th>
              <th>Idade</th>
              <th>Nascimento</th>
              <th>Admissão</th>
              <th>Diagnóstico</th>
              <th>Grau</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(resident, key) in data" :key="key">
              <td class="text-center">
                <img
                  v-if="resident.photo_url"
                  style="
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    object-fit: cover;
                  "
                  :src="resident.photo_url"
                />
                <img
                  v-if="!resident.photo_url"
                  style="
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    object-fit: cover;
                  "
                  :src="require('../../assets/user.png')"
                />
              </td>
              <td>{{ resident.name }}</td>
              <td>{{ resident.cpf }}</td>
              <td>{{ getAge(resident.date_of_birth) }}</td>
              <td>{{ formatDate(resident.date_of_birth, false) }}</td>
              <td>{{ formatDate(resident.date_of_reception, false) }}</td>
              <td>{{ resident.pathology }}</td>
              <td>{{ resident.degree_of_dependence_name }}</td>
            </tr>
          </tbody>

          <!-- Rodapé com totalizadores -->
          <tfoot>
            <tr>
              <!-- Bloco 1: Quantidade de Graus -->
              <td colspan="2" class="tfoot-block">
                <table class="tfoot-inner-table">
                  <thead>
                    <tr>
                      <th colspan="3" class="tfoot-inner-header">
                        QUANTIDADE DE GRAUS
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>GRAU 1</td>
                      <td class="tfoot-value">{{ totalGrau1 }}</td>
                    </tr>
                    <tr>
                      <td>GRAU 2</td>
                      <td class="tfoot-value">{{ totalGrau2 }}</td>
                    </tr>
                    <tr>
                      <td>GRAU 3</td>
                      <td class="tfoot-value">{{ totalGrau3 }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <!-- Bloco 2: Por Sexo -->
              <td colspan="3" class="tfoot-block">
                <table class="tfoot-inner-table">
                  <thead>
                    <tr>
                      <th colspan="3" class="tfoot-inner-header">POR SEXO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>HOMENS</td>
                      <td class="tfoot-value">{{ totalHomens }}</td>
                    </tr>
                    <tr>
                      <td>MULHERES</td>
                      <td class="tfoot-value">{{ totalMulheres }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <!-- Bloco 3: Total Geral -->
              <td colspan="3" class="tfoot-block tfoot-total">
                <div class="tfoot-total-label">TOTAL DE RESIDENTES</div>
                <div class="tfoot-total-number">{{ totalGeral }}</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="text-right">
          <h6 class="mb-0 worksansr">
            Gerado por:
            <strong>
              {{
                professionalClassCouncilValue({
                  id: user.professional_class_council_id,
                  name: user.name,
                  profile: user.profile_name,
                  cpf: user.cpf,
                  office: user.office,
                  value: user.professional_class_council_value,
                })
              }}
              <span class="ml-1">
                - {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
              </span>
            </strong>
          </h6>
        </div>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import routes from "../../routes";

import {
  formatDate,
  formatPrice,
  formatDateToMonthYear,
  professionalClassCouncilValue,
} from "../../lib/format";

import { getAge } from "../../lib/getAgeByDate";

import { userData } from "../../lib/functions";

import moment from "moment";

export default {
  name: "ReportsResidentsDegreeOfDependence",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },

  data() {
    return {
      resident_active: "ATIVO",
      resident_id: "",
      degree_of_dependence_id: "",
      gender_id: "",
      residents: [],
      data: [],
      user: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      loading: false,
      errors: [],

      typesFilterByGrau: [
        { value: "1", text: "GRAU 1" },
        { value: "2", text: "GRAU 2" },
        { value: "3", text: "GRAU 3" },
      ],

      genders: [
        { value: "1", text: "FEMININO" },
        { value: "2", text: "MASCULINO" },
      ],

      geral: true,
      endereco: true,
      documentos: true,
      familiares: true,
      convenios: true,
      hospedagem: true,
      encerramento_contrato: true,

      user_allow_home_care: 0,
      rest_home_allow_home_care: 0,
    };
  },

  created() {
    this.retrieve();
  },

  computed: {
    totalGrau1() {
      return this.data.filter((r) => r.degree_of_dependence_name === "GRAU1")
        .length;
    },
    totalGrau2() {
      return this.data.filter((r) => r.degree_of_dependence_name === "GRAU2")
        .length;
    },
    totalGrau3() {
      return this.data.filter((r) => r.degree_of_dependence_name === "GRAU3")
        .length;
    },
    totalHomens() {
      // gender: 2 = masculino, conforme genders do data()
      return this.data.filter(
        (r) => r.gender_id == 2 || r.gender == "MASCULINO" || r.gender == "M"
      ).length;
    },
    totalMulheres() {
      return this.data.filter(
        (r) => r.gender_id == 1 || r.gender == "FEMININO" || r.gender == "F"
      ).length;
    },
    totalGeral() {
      return this.data.length;
    },
  },

  methods: {
    getAge,
    moment,
    formatDate,
    formatPrice,
    formatDateToMonthYear,
    professionalClassCouncilValue,

    async retrieve() {
      const { user } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.user_allow_home_care = user.allow_home_care;
      this.rest_home_allow_home_care = user.rest_home_allow_home_care;

      await this.getResidents();

      if (this.errors.length == 0 && this.resident_id) {
        await this.paginate();
      }

      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },

    async getResidents() {
      try {
        let { resident_active } = this;

        let status = "ATIVO";

        if (resident_active == "TODOS") {
          status = "ALL";
        } else if (resident_active == "INATIVO") {
          status = "INATIVO";
        } else if (!["TODOS", "ATIVO", "INATIVO"].includes(resident_active)) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        const {
          resident_id,
          resident_active,
          degree_of_dependence_id,
          gender_id,
          geral,
          endereco,
          documentos,
          familiares,
          convenios,
          hospedagem,
          encerramento_contrato,
        } = this;

        let params = {
          resident_id,
          resident_active,
          degree_of_dependence_id,
          gender_id,
          geral,
          endereco,
          documentos,
          familiares,
          convenios,
          hospedagem,
          encerramento_contrato,
        };

        const response = await api.get("/rest-home/report/residents", {
          params,
        });

        const { data, error, errors } = response.data;

        if (error) {
          this.data = [];
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToPrint: () => window.print(),

    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
/* Altura uniforme e compacta nas células da tabela */
.pdf-report-residents .table td,
.pdf-report-residents .table th {
  height: 28px;
  max-height: 28px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  vertical-align: middle !important;
  font-size: 14px;
}

/* Cabeçalho pode ter altura levemente maior para destaque visual */

/* Larguras proporcionais por coluna */
.pdf-report-residents .table th:nth-child(1),
.pdf-report-residents .table td:nth-child(1) {
  width: 16%;
}

.pdf-report-residents .table th:nth-child(2),
.pdf-report-residents .table td:nth-child(2) {
  width: 12%;
}

.pdf-report-residents .table th:nth-child(3),
.pdf-report-residents .table td:nth-child(3) {
  width: 6%;
}

.pdf-report-residents .table th:nth-child(4),
.pdf-report-residents .table td:nth-child(4) {
  width: 10%;
}

.pdf-report-residents .table th:nth-child(5),
.pdf-report-residents .table td:nth-child(5) {
  width: 10%;
}

.pdf-report-residents .table th:nth-child(7),
.pdf-report-residents .table td:nth-child(7) {
  width: 6%;
}

.pdf-report-residents .table th:nth-child(6),
.pdf-report-residents .table td:nth-child(6) {
  width: 40%;
}

/* Garante que a tabela respeite as larguras definidas */
.pdf-report-residents .table {
  table-layout: fixed;
  width: 100%;
}

/* Remove o max-width genérico que conflita com as larguras acima */
.pdf-report-residents .table td,
.pdf-report-residents .table th {
  max-width: unset;
}

/* Rodapé da tabela - container dos blocos */
.pdf-report-residents .tfoot-block {
  padding: 0 !important;
  vertical-align: top !important;
  height: auto !important;
  max-height: none !important;
}

/* Tabela interna dos blocos de grau e sexo */
.pdf-report-residents .tfoot-inner-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.pdf-report-residents .tfoot-inner-table td,
.pdf-report-residents .tfoot-inner-table th {
  border: none !important;
  padding: 2px 6px !important;
  height: 24px !important;
  max-height: 24px !important;
  font-size: 13px;
  width: auto !important;
}

/* Cabeçalho dos blocos internos */
.pdf-report-residents .tfoot-inner-header {
  font-weight: 700 !important;
  text-align: center !important;
  border-bottom: 1px solid #dee2e6 !important;
  padding: 4px 6px !important;
  font-size: 13px !important;
}

/* Valor numérico alinhado à direita */
.pdf-report-residents .tfoot-value {
  font-weight: 700;
  text-align: right !important;
}

/* Bloco de total geral */
.pdf-report-residents .tfoot-total {
  text-align: center !important;
  vertical-align: middle !important;
}

.pdf-report-residents .tfoot-total-label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
}

.pdf-report-residents .tfoot-total-number {
  font-size: 36px;
  font-weight: 700;
  line-height: 1;
}

.pdf-report-residents p {
  font-weight: 100 !important;
}
.pdf-report-residents .text-amount {
  font-size: 13px;
}

.pdf-report-residents .date-amount {
  font-size: 13px;
}

.pdf-report-residents .logo {
  width: 100%;
  height: 50px;
  object-fit: contain;
}

.pdf-report-residents .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.pdf-report-residents .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  object-fit: cover;
}

.pdf-report-residents small {
  font-size: 12px;
}

@media print {
  body {
    margin: 0 !important;
    line-height: 1.4em !important;
  }

  .pdf-report-residents button {
    display: none;
  }

  .pdf-report-residents .nav--bar {
    display: none !important;
  }

  .pdf-report-residents .auth--by--session--expired {
    display: none !important;
  }

  .pdf-report-residents .content-filter {
    display: none;
  }
}
</style>
